module.exports = __webpack_public_path__ + "2f2440e0234b7e117f350678a6540dad.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/accessibility/telephone.svg
// module id = fMXK
// module chunks = 0